import React, { ChangeEvent, FC, RefObject, useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';

import Button from '../buttons/Button';
import { CheckboxComponent } from '../../ReusableComponents/Checkbox/CheckboxComponent';
import { InputComponent } from '../../ReusableComponents/Input/InputComponent';

interface ControlSortListFiltersType {
  allSenders: Set<string>;
  filterInputValue: string;
  inputRef: RefObject<HTMLInputElement>;
  selectedSenders: Set<string>;
  onSetSelectedSenders: (allSenders: Set<string>) => void;
  onCheckboxChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onFilterInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
}
export const ControlSortListFilters: FC<ControlSortListFiltersType> = ({
  allSenders = new Set(),
  filterInputValue,
  inputRef,
  selectedSenders,
  onCheckboxChange,
  onFilterInputChange,
  onSetSelectedSenders,
}): JSX.Element => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  const handleCollapseExpand = (): void => setIsCollapsed(!isCollapsed);

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>): void =>
    onCheckboxChange(event);
  const handleSetSelectedSenders = (senders: Set<string>): void =>
    onSetSelectedSenders(senders);
  const handleFilterInputChange = (
    event: ChangeEvent<HTMLInputElement>
  ): void => onFilterInputChange(event);

  return (
    <>
      <div className="sort-list__filter__header">
        <div>
          Filter senders:{' '}
          <Button
            title="All"
            type="slim"
            onClick={() => handleSetSelectedSenders(allSenders)}
          />
          {'  '}
          <Button
            title="None"
            type="slim"
            onClick={() => handleSetSelectedSenders(new Set())}
          />
        </div>
        <IconButton onClick={handleCollapseExpand}>
          {isCollapsed ? <FaAngleDown /> : <FaAngleUp />}
        </IconButton>
      </div>
      <div
        style={{ display: isCollapsed ? 'none' : 'block' }}
        className="sort-list__filter__list"
      >
        <div>
          {Array.from(allSenders).map(senderName => {
            return (
              <CheckboxComponent
                key={senderName}
                checked={selectedSenders && selectedSenders.has(senderName)}
                label={senderName}
                handleChange={handleCheckboxChange}
                name={senderName}
              />
            );
          })}
        </div>
        <InputComponent
          className="sort-list-filter-input"
          type="text"
          fullWidth
          variant="outlined"
          id="sort-list-filter"
          label="Courier/Shelf/Order filter"
          name="sort-list-filter"
          onChange={handleFilterInputChange}
          value={filterInputValue}
          inputRef={inputRef}
        />
      </div>
    </>
  );
};
